import { Navigate, useLocation } from 'react-router-dom';
import { RoutePaths, SessionStorageUtils } from '@shared/utils';
import { PageLayout } from '@shared/widgets/pageLayout';

export const PrivateRoute = (props: { children: React.ReactNode }) => {
  const location = useLocation();

  const token = SessionStorageUtils.getToken();

  const isLoggedIn = !!token;

  return isLoggedIn ? <PageLayout>{props.children}</PageLayout> : <Navigate to={RoutePaths.login.onNavigate()} state={{ from: location.pathname }} />;
};
